import useGetInitialLanguage from './useGetInitialLanguage'

export default useGetInitialLanguage
